module.exports = __webpack_public_path__ + "771ccd6c54f71c87016fcb3399d2a084.svg";